import React from 'react';
import styled from 'styled-components';
import { device } from '../utils/devices';

const SocialBlock = styled.nav`
  padding: 4rem;

  display: none;

  @media ${device.laptop} {
    display: block;
    padding: 4rem;
    min-height: 40px;
  }
`;

const List = styled.ul`
  padding: 0;
  margin: 0;
  font-size: 24px;
  list-style-type: none;
  display: flex;
  justify-content: space-between;
`;

const ListItem = styled.li`
  a {
    color: black;
    text-decoration: none;

    &:hover {
      color: ${props => props.theme.bg};
    }
  }
`;

const Social = (props) => {
  return (
    <SocialBlock>
      <List>
        <ListItem><a rel="noopener noreferrer" target="_blank" href="https://www.facebook.com/YouDoYouStudio/">Facebook <small>&#8599;</small></a></ListItem>
        <ListItem><a rel="noopener noreferrer" target="_blank" href="https://www.instagram.com/youdoyoustudio/">Instagram <small>&#8599;</small></a></ListItem>
      </List>
    </SocialBlock>
  )
}

export default Social;



// WEBPACK FOOTER //
// ./src/components/Social.js